<template>
    <div id="app">
        <main-header nowtab="bbs"></main-header>
        <main class="adjuster">
            <a-page-header
                style="border: 1px solid rgb(235, 237, 240)"
                :title="title"
                @back="back()"
            >
                <template slot="extra">
                    <a-button @click="triggerHostonly()">
                        {{ hostonly ? '浏览全部' : '只看楼主' }} 
                    </a-button>
                </template>
            </a-page-header>
            <a-pagination :current="Number(pagenow)" :total="total" class="top-pager"
                :defaultPageSize="10" @change="turnPage" :hideOnSinglePage="true"
            />
            <a-divider></a-divider>
            <a-list
                class="thread-list"
                item-layout="horizontal"
                :data-source="data"
            >
                <a-list-item slot="renderItem" slot-scope="item">
                    <a-list-item-meta>
                        <div slot="avatar" class="avatar-container">
                            <a-avatar :src="item.avatar" shape="square" :size="72"/>
                            <user-link :name="item.author" :id="item.authorid"/>
                        </div>
                        <Post slot="description" :item="item" @edit="openEditDialog"></Post>
                    </a-list-item-meta>
                </a-list-item>
            </a-list>
            <a-divider></a-divider>
            <a-pagination :current="Number(pagenow)" :total="total" 
                :defaultPageSize="10" @change="turnPage" :hideOnSinglePage="true"
            />
            <div v-show="hasLogin" id="editor">
                <wang-editor v-model="postData"></wang-editor>
                <a-button type="primary" id="reply" :loading="posting">回复</a-button>
            </div>
            <a-result v-show="!hasLogin" title="尚未登录，请登录后回复">
                <template #icon></template>
                <template #extra>
                <a-button type="primary">
                    <a href="/login">登录</a>
                </a-button>
                </template>
            </a-result>
            <a-modal
                :title="`编辑帖子 - ${editpid}楼`"
                :visible="visible"
                :confirm-loading="editing"
                @ok="doEdit"
                @cancel="() => visible = false"
                width="95%"
            >
                <wang-editor ref="edit" v-model="editData"></wang-editor>
            </a-modal>
        </main>
        <Footer></Footer>
    </div>
</template>

<script>
import MainHeader from '@/components/MainHeader'
import UserLink from '@/components/UserLink.vue';
import Footer from '@/components/Footer'
import WangEditor from '@/components/WangEditor'
import Post from './Post.vue'
import axios from 'axios';
import { mapState } from 'vuex';
import { createFormData, getSSRdata } from '../../utils/utils';

export default {
    data: () => ({
        data: [],
        bid: 0,
        tid: 0,
        pagenow: 0,
        total: 0,
        title: '',
        hostonly: false,
        postData: "",
        posting: false,
        visible: false,
        editData: "",
        editing: false,
        editpid: -1,
    }),
    computed: {
        ...mapState({ hasLogin: 'hasLogin' }),
    },
    async created() {
        const {
            thread: { bid, tid, title }, page, hostonly, list, total
        } = getSSRdata("thread");
        this.bid = bid;
        this.tid = tid;
        this.pagenow = page;
        this.hostonly = hostonly;
        this.data = list;
        this.total = total;
        this.title = title;
        document.title = title + " - HTML5魔塔广场";
    },
    methods: {
        back() {
            window.location.pathname = "/bbs";
        },
        turnPage(page) {
            if (this.hostonly) {
                window.location.search = `?bid=${this.bid}&tid=${this.tid}&p=${page}&hostonly=1`;
            } else {
                window.location.search = `?bid=${this.bid}&tid=${this.tid}&p=${page}`;
            }
        },
        triggerHostonly() {
            if (this.hostonly) {
                window.location.search = `?bid=${this.bid}&tid=${this.tid}&p=${this.pagenow}`;
            } else {
                window.location.search = `?bid=${this.bid}&tid=${this.tid}&p=${this.pagenow}&hostonly=1`;
            }
        },
        doReply() {
            this.posting = true;
            let content = this.postData;
            content = content.replace(/&/g, "&amp;");
            if (content == "" || content == "<br>") {
                alert("请填写回复内容！");
                return;
            }

            axios.post("/backend/bbs/post.php", createFormData({
                bid: this.bid,
                tid: this.tid,
                text: content,
                title: `Re: ${this.title}`
            })).then(({ data }) => {
                this.posting = false;
                if (data.code == 0) {
                    this.$message.success('发布成功');
                    window.location.reload();
                } else
                    alert("错误：" + data.msg);
            });
        },
        openEditDialog({ pid, text }) {
            this.editpid = pid;
            if (this.$refs.edit) {
                this.$refs.edit.setValue(text);
            } else {
                this.editData = text;
            }
            this.visible = true;
        },
        async doEdit() {
            const { data } = await axios.post("/backend/bbs/edit.php", createFormData({
                bid: this.bid,
                tid: this.tid,
                pid: this.editpid,
                text: this.editData,
                title: `Re: ${this.title}`
            }));
            this.posting = false;
            if (data.code == 0) {
                this.visible = false;
                this.$message.success('修改成功');
            } else
                alert("错误：" + data.msg);
        }
    },
    components: {
        MainHeader, Footer, UserLink, Post, WangEditor,
    }
}
</script>

<style>
html, body {
    height: 100%;
    width: 100%;
    margin: 0;
}
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    cursor: default;
}
.adjuster {
    max-width: 1000px;
    margin: 20px auto;
}
.avatar-container {
    width: 96px;
    display: flex;
    flex-direction: column;
    align-items: center;
}
#editor {
    margin-top: 20px;
    text-align: left;
}
#editorContainer {
    margin: 10px 0px;
    cursor: text;
}
#reply {
    margin-left: 15px;
}
.ant-pagination.top-pager {
    margin-top: 10px;
    margin-bottom: -10px;
}
</style>

